<template>
  <v-snackbar v-model="internalValue" top right color="error" class="error-message">
    {{ errorText }}
  </v-snackbar>
</template>
<script>
export default {
  name: 'ErrorMessage',
  props: {
    errorText: {
      type: String,
      required: true,
    },
  },
  computed: {
    internalValue: {
      get() {
        return !!this.errorText;
      },
      set() {
        this.$emit('close');
      },
    },
  },
};
</script>
